import React from "react";
import PropTypes from "prop-types";
import { Col, Row, FormCheckbox } from "shards-react";

const ConfigurationsCardComponent = props => {
    const {
        configurations: [status, visible],
        handleSwitchStatus,
        handleSwitchChange,
        hasWriteMiniAppScope,
        hasWriteMiniAppAction
    } = props;
    return (
        <React.Fragment>
            <Row>
                <Col style={{ fontWeight: "600" }}>Configurações:</Col>
            </Row>
            &nbsp;
            <Col className="d-flex flex-column">
                <FormCheckbox
                    disabled={!hasWriteMiniAppScope && !hasWriteMiniAppAction}
                    inline
                    checked={!!(status === "ACTIVE")}
                    name={"status"}
                    onChange={handleSwitchStatus}
                >
                    Ativo
                </FormCheckbox>
                <FormCheckbox
                    disabled={!hasWriteMiniAppScope && !hasWriteMiniAppAction}
                    inline
                    checked={visible}
                    name={"visible"}
                    onChange={() => handleSwitchChange("visible")}
                >
                    Visível
                </FormCheckbox>
            </Col>
        </React.Fragment>
    );
};

ConfigurationsCardComponent.propTypes = {
    configurations: PropTypes.array,
    status: PropTypes.string,
    visible: PropTypes.bool,
    acceptCashback: PropTypes.bool,
    autoCapture: PropTypes.bool,
    handleSwitchStatus: PropTypes.func,
    handleSwitchChange: PropTypes.func,
    hasWriteMiniAppScope: PropTypes.bool,
    hasWriteMiniAppAction: PropTypes.bool
};
export default ConfigurationsCardComponent;
